// source: pangolin/protos/schedules.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */


var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.pangolin.protos.GetScheduleHostsResponse', null, global);
goog.exportSymbol('proto.pangolin.protos.GetSchedulePoliciesResponse', null, global);
goog.exportSymbol('proto.pangolin.protos.GetSchedulePolicyResponse', null, global);
goog.exportSymbol('proto.pangolin.protos.GetScheduleResponse', null, global);
goog.exportSymbol('proto.pangolin.protos.GetSchedulesResponse', null, global);
goog.exportSymbol('proto.pangolin.protos.ScheduleDayFlag', null, global);
goog.exportSymbol('proto.pangolin.protos.ScheduleError', null, global);
goog.exportSymbol('proto.pangolin.protos.ScheduleErrorMap', null, global);
goog.exportSymbol('proto.pangolin.protos.ScheduleErrorMapTuple', null, global);
goog.exportSymbol('proto.pangolin.protos.ScheduleHostErrorMap', null, global);
goog.exportSymbol('proto.pangolin.protos.ScheduleHostErrorMapTuple', null, global);
goog.exportSymbol('proto.pangolin.protos.ScheduleHostIdList', null, global);
goog.exportSymbol('proto.pangolin.protos.ScheduleObject', null, global);
goog.exportSymbol('proto.pangolin.protos.ScheduleObjectMap', null, global);
goog.exportSymbol('proto.pangolin.protos.ScheduleObjectMapTuple', null, global);
goog.exportSymbol('proto.pangolin.protos.SchedulePolicyCategory', null, global);
goog.exportSymbol('proto.pangolin.protos.SchedulePolicyError', null, global);
goog.exportSymbol('proto.pangolin.protos.SchedulePolicyErrorMap', null, global);
goog.exportSymbol('proto.pangolin.protos.SchedulePolicyErrorMapTuple', null, global);
goog.exportSymbol('proto.pangolin.protos.SchedulePolicyKind', null, global);
goog.exportSymbol('proto.pangolin.protos.SchedulePolicyObject', null, global);
goog.exportSymbol('proto.pangolin.protos.SchedulePolicyObject.ValueCase', null, global);
goog.exportSymbol('proto.pangolin.protos.SchedulePolicyObjectMap', null, global);
goog.exportSymbol('proto.pangolin.protos.SchedulePolicyObjectMapTuple', null, global);
goog.exportSymbol('proto.pangolin.protos.SetScheduleHostsRequest', null, global);
goog.exportSymbol('proto.pangolin.protos.SetScheduleHostsResponseInvalid', null, global);
goog.exportSymbol('proto.pangolin.protos.SetSchedulePoliciesRequest', null, global);
goog.exportSymbol('proto.pangolin.protos.SetSchedulePoliciesResponseInvalid', null, global);
goog.exportSymbol('proto.pangolin.protos.SetSchedulePolicyRequest', null, global);
goog.exportSymbol('proto.pangolin.protos.SetSchedulePolicyResponseInvalid', null, global);
goog.exportSymbol('proto.pangolin.protos.SetScheduleRequest', null, global);
goog.exportSymbol('proto.pangolin.protos.SetScheduleResponseInvalid', null, global);
goog.exportSymbol('proto.pangolin.protos.SetSchedulesRequest', null, global);
goog.exportSymbol('proto.pangolin.protos.SetSchedulesResponseInvalid', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.ScheduleDayFlag = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.ScheduleDayFlag, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.ScheduleDayFlag.displayName = 'proto.pangolin.protos.ScheduleDayFlag';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.ScheduleHostIdList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pangolin.protos.ScheduleHostIdList.repeatedFields_, null);
};
goog.inherits(proto.pangolin.protos.ScheduleHostIdList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.ScheduleHostIdList.displayName = 'proto.pangolin.protos.ScheduleHostIdList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.SchedulePolicyObject = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.pangolin.protos.SchedulePolicyObject.oneofGroups_);
};
goog.inherits(proto.pangolin.protos.SchedulePolicyObject, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.SchedulePolicyObject.displayName = 'proto.pangolin.protos.SchedulePolicyObject';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.SchedulePolicyObjectMap = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pangolin.protos.SchedulePolicyObjectMap.repeatedFields_, null);
};
goog.inherits(proto.pangolin.protos.SchedulePolicyObjectMap, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.SchedulePolicyObjectMap.displayName = 'proto.pangolin.protos.SchedulePolicyObjectMap';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.SchedulePolicyObjectMapTuple = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.SchedulePolicyObjectMapTuple, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.SchedulePolicyObjectMapTuple.displayName = 'proto.pangolin.protos.SchedulePolicyObjectMapTuple';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.ScheduleObject = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.ScheduleObject, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.ScheduleObject.displayName = 'proto.pangolin.protos.ScheduleObject';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.ScheduleObjectMap = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pangolin.protos.ScheduleObjectMap.repeatedFields_, null);
};
goog.inherits(proto.pangolin.protos.ScheduleObjectMap, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.ScheduleObjectMap.displayName = 'proto.pangolin.protos.ScheduleObjectMap';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.ScheduleObjectMapTuple = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.ScheduleObjectMapTuple, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.ScheduleObjectMapTuple.displayName = 'proto.pangolin.protos.ScheduleObjectMapTuple';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.ScheduleHostErrorMap = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pangolin.protos.ScheduleHostErrorMap.repeatedFields_, null);
};
goog.inherits(proto.pangolin.protos.ScheduleHostErrorMap, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.ScheduleHostErrorMap.displayName = 'proto.pangolin.protos.ScheduleHostErrorMap';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.ScheduleHostErrorMapTuple = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pangolin.protos.ScheduleHostErrorMapTuple.repeatedFields_, null);
};
goog.inherits(proto.pangolin.protos.ScheduleHostErrorMapTuple, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.ScheduleHostErrorMapTuple.displayName = 'proto.pangolin.protos.ScheduleHostErrorMapTuple';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.SchedulePolicyError = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pangolin.protos.SchedulePolicyError.repeatedFields_, null);
};
goog.inherits(proto.pangolin.protos.SchedulePolicyError, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.SchedulePolicyError.displayName = 'proto.pangolin.protos.SchedulePolicyError';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.SchedulePolicyErrorMap = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pangolin.protos.SchedulePolicyErrorMap.repeatedFields_, null);
};
goog.inherits(proto.pangolin.protos.SchedulePolicyErrorMap, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.SchedulePolicyErrorMap.displayName = 'proto.pangolin.protos.SchedulePolicyErrorMap';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.SchedulePolicyErrorMapTuple = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.SchedulePolicyErrorMapTuple, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.SchedulePolicyErrorMapTuple.displayName = 'proto.pangolin.protos.SchedulePolicyErrorMapTuple';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.ScheduleError = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pangolin.protos.ScheduleError.repeatedFields_, null);
};
goog.inherits(proto.pangolin.protos.ScheduleError, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.ScheduleError.displayName = 'proto.pangolin.protos.ScheduleError';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.ScheduleErrorMap = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pangolin.protos.ScheduleErrorMap.repeatedFields_, null);
};
goog.inherits(proto.pangolin.protos.ScheduleErrorMap, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.ScheduleErrorMap.displayName = 'proto.pangolin.protos.ScheduleErrorMap';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.ScheduleErrorMapTuple = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.ScheduleErrorMapTuple, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.ScheduleErrorMapTuple.displayName = 'proto.pangolin.protos.ScheduleErrorMapTuple';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.GetSchedulesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.GetSchedulesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.GetSchedulesResponse.displayName = 'proto.pangolin.protos.GetSchedulesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.SetSchedulesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.SetSchedulesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.SetSchedulesRequest.displayName = 'proto.pangolin.protos.SetSchedulesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.SetSchedulesResponseInvalid = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.SetSchedulesResponseInvalid, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.SetSchedulesResponseInvalid.displayName = 'proto.pangolin.protos.SetSchedulesResponseInvalid';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.GetScheduleResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.GetScheduleResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.GetScheduleResponse.displayName = 'proto.pangolin.protos.GetScheduleResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.SetScheduleRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.SetScheduleRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.SetScheduleRequest.displayName = 'proto.pangolin.protos.SetScheduleRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.SetScheduleResponseInvalid = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.SetScheduleResponseInvalid, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.SetScheduleResponseInvalid.displayName = 'proto.pangolin.protos.SetScheduleResponseInvalid';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.GetScheduleHostsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.GetScheduleHostsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.GetScheduleHostsResponse.displayName = 'proto.pangolin.protos.GetScheduleHostsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.SetScheduleHostsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.SetScheduleHostsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.SetScheduleHostsRequest.displayName = 'proto.pangolin.protos.SetScheduleHostsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.SetScheduleHostsResponseInvalid = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.SetScheduleHostsResponseInvalid, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.SetScheduleHostsResponseInvalid.displayName = 'proto.pangolin.protos.SetScheduleHostsResponseInvalid';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.GetSchedulePoliciesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.GetSchedulePoliciesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.GetSchedulePoliciesResponse.displayName = 'proto.pangolin.protos.GetSchedulePoliciesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.SetSchedulePoliciesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.SetSchedulePoliciesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.SetSchedulePoliciesRequest.displayName = 'proto.pangolin.protos.SetSchedulePoliciesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.SetSchedulePoliciesResponseInvalid = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.SetSchedulePoliciesResponseInvalid, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.SetSchedulePoliciesResponseInvalid.displayName = 'proto.pangolin.protos.SetSchedulePoliciesResponseInvalid';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.GetSchedulePolicyResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.GetSchedulePolicyResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.GetSchedulePolicyResponse.displayName = 'proto.pangolin.protos.GetSchedulePolicyResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.SetSchedulePolicyRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.SetSchedulePolicyRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.SetSchedulePolicyRequest.displayName = 'proto.pangolin.protos.SetSchedulePolicyRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pangolin.protos.SetSchedulePolicyResponseInvalid = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pangolin.protos.SetSchedulePolicyResponseInvalid, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pangolin.protos.SetSchedulePolicyResponseInvalid.displayName = 'proto.pangolin.protos.SetSchedulePolicyResponseInvalid';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.ScheduleDayFlag.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.ScheduleDayFlag.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.ScheduleDayFlag} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.ScheduleDayFlag.toObject = function(includeInstance, msg) {
  var f, obj = {
    monday: (f = jspb.Message.getBooleanField(msg, 1)) == null ? undefined : f,
    tuesday: (f = jspb.Message.getBooleanField(msg, 2)) == null ? undefined : f,
    wednesday: (f = jspb.Message.getBooleanField(msg, 3)) == null ? undefined : f,
    thursday: (f = jspb.Message.getBooleanField(msg, 4)) == null ? undefined : f,
    friday: (f = jspb.Message.getBooleanField(msg, 5)) == null ? undefined : f,
    saturday: (f = jspb.Message.getBooleanField(msg, 6)) == null ? undefined : f,
    sunday: (f = jspb.Message.getBooleanField(msg, 7)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.ScheduleDayFlag}
 */
proto.pangolin.protos.ScheduleDayFlag.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.ScheduleDayFlag;
  return proto.pangolin.protos.ScheduleDayFlag.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.ScheduleDayFlag} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.ScheduleDayFlag}
 */
proto.pangolin.protos.ScheduleDayFlag.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMonday(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setTuesday(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setWednesday(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setThursday(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFriday(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSaturday(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSunday(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.ScheduleDayFlag.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.ScheduleDayFlag.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.ScheduleDayFlag} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.ScheduleDayFlag.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {boolean} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeBool(
      1,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeBool(
      2,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeBool(
      3,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeBool(
      4,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeBool(
      5,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeBool(
      6,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeBool(
      7,
      f
    );
  }
};


/**
 * optional bool monday = 1;
 * @return {boolean}
 */
proto.pangolin.protos.ScheduleDayFlag.prototype.getMonday = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pangolin.protos.ScheduleDayFlag} returns this
 */
proto.pangolin.protos.ScheduleDayFlag.prototype.setMonday = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.ScheduleDayFlag} returns this
 */
proto.pangolin.protos.ScheduleDayFlag.prototype.clearMonday = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.ScheduleDayFlag.prototype.hasMonday = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bool tuesday = 2;
 * @return {boolean}
 */
proto.pangolin.protos.ScheduleDayFlag.prototype.getTuesday = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pangolin.protos.ScheduleDayFlag} returns this
 */
proto.pangolin.protos.ScheduleDayFlag.prototype.setTuesday = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.ScheduleDayFlag} returns this
 */
proto.pangolin.protos.ScheduleDayFlag.prototype.clearTuesday = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.ScheduleDayFlag.prototype.hasTuesday = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional bool wednesday = 3;
 * @return {boolean}
 */
proto.pangolin.protos.ScheduleDayFlag.prototype.getWednesday = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pangolin.protos.ScheduleDayFlag} returns this
 */
proto.pangolin.protos.ScheduleDayFlag.prototype.setWednesday = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.ScheduleDayFlag} returns this
 */
proto.pangolin.protos.ScheduleDayFlag.prototype.clearWednesday = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.ScheduleDayFlag.prototype.hasWednesday = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional bool thursday = 4;
 * @return {boolean}
 */
proto.pangolin.protos.ScheduleDayFlag.prototype.getThursday = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pangolin.protos.ScheduleDayFlag} returns this
 */
proto.pangolin.protos.ScheduleDayFlag.prototype.setThursday = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.ScheduleDayFlag} returns this
 */
proto.pangolin.protos.ScheduleDayFlag.prototype.clearThursday = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.ScheduleDayFlag.prototype.hasThursday = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional bool friday = 5;
 * @return {boolean}
 */
proto.pangolin.protos.ScheduleDayFlag.prototype.getFriday = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pangolin.protos.ScheduleDayFlag} returns this
 */
proto.pangolin.protos.ScheduleDayFlag.prototype.setFriday = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.ScheduleDayFlag} returns this
 */
proto.pangolin.protos.ScheduleDayFlag.prototype.clearFriday = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.ScheduleDayFlag.prototype.hasFriday = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional bool saturday = 6;
 * @return {boolean}
 */
proto.pangolin.protos.ScheduleDayFlag.prototype.getSaturday = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pangolin.protos.ScheduleDayFlag} returns this
 */
proto.pangolin.protos.ScheduleDayFlag.prototype.setSaturday = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.ScheduleDayFlag} returns this
 */
proto.pangolin.protos.ScheduleDayFlag.prototype.clearSaturday = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.ScheduleDayFlag.prototype.hasSaturday = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional bool sunday = 7;
 * @return {boolean}
 */
proto.pangolin.protos.ScheduleDayFlag.prototype.getSunday = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pangolin.protos.ScheduleDayFlag} returns this
 */
proto.pangolin.protos.ScheduleDayFlag.prototype.setSunday = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.ScheduleDayFlag} returns this
 */
proto.pangolin.protos.ScheduleDayFlag.prototype.clearSunday = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.ScheduleDayFlag.prototype.hasSunday = function() {
  return jspb.Message.getField(this, 7) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pangolin.protos.ScheduleHostIdList.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.ScheduleHostIdList.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.ScheduleHostIdList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.ScheduleHostIdList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.ScheduleHostIdList.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.ScheduleHostIdList}
 */
proto.pangolin.protos.ScheduleHostIdList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.ScheduleHostIdList;
  return proto.pangolin.protos.ScheduleHostIdList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.ScheduleHostIdList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.ScheduleHostIdList}
 */
proto.pangolin.protos.ScheduleHostIdList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.ScheduleHostIdList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.ScheduleHostIdList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.ScheduleHostIdList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.ScheduleHostIdList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string items = 1;
 * @return {!Array<string>}
 */
proto.pangolin.protos.ScheduleHostIdList.prototype.getItemsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pangolin.protos.ScheduleHostIdList} returns this
 */
proto.pangolin.protos.ScheduleHostIdList.prototype.setItemsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.ScheduleHostIdList} returns this
 */
proto.pangolin.protos.ScheduleHostIdList.prototype.addItems = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.ScheduleHostIdList} returns this
 */
proto.pangolin.protos.ScheduleHostIdList.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.pangolin.protos.SchedulePolicyObject.oneofGroups_ = [[3,4]];

/**
 * @enum {number}
 */
proto.pangolin.protos.SchedulePolicyObject.ValueCase = {
  VALUE_NOT_SET: 0,
  CATEGORY: 3,
  CUSTOM: 4
};

/**
 * @return {proto.pangolin.protos.SchedulePolicyObject.ValueCase}
 */
proto.pangolin.protos.SchedulePolicyObject.prototype.getValueCase = function() {
  return /** @type {proto.pangolin.protos.SchedulePolicyObject.ValueCase} */(jspb.Message.computeOneofCase(this, proto.pangolin.protos.SchedulePolicyObject.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.SchedulePolicyObject.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.SchedulePolicyObject.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.SchedulePolicyObject} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.SchedulePolicyObject.toObject = function(includeInstance, msg) {
  var f, obj = {
    uuid: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    kind: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
    category: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
    custom: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.SchedulePolicyObject}
 */
proto.pangolin.protos.SchedulePolicyObject.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.SchedulePolicyObject;
  return proto.pangolin.protos.SchedulePolicyObject.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.SchedulePolicyObject} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.SchedulePolicyObject}
 */
proto.pangolin.protos.SchedulePolicyObject.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    case 2:
      var value = /** @type {!proto.pangolin.protos.SchedulePolicyKind} */ (reader.readEnum());
      msg.setKind(value);
      break;
    case 3:
      var value = /** @type {!proto.pangolin.protos.SchedulePolicyCategory} */ (reader.readEnum());
      msg.setCategory(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCustom(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.SchedulePolicyObject.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.SchedulePolicyObject.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.SchedulePolicyObject} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.SchedulePolicyObject.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {!proto.pangolin.protos.SchedulePolicyKind} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = /** @type {!proto.pangolin.protos.SchedulePolicyCategory} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.pangolin.protos.SchedulePolicyObject.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.SchedulePolicyObject} returns this
 */
proto.pangolin.protos.SchedulePolicyObject.prototype.setUuid = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.SchedulePolicyObject} returns this
 */
proto.pangolin.protos.SchedulePolicyObject.prototype.clearUuid = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.SchedulePolicyObject.prototype.hasUuid = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional SchedulePolicyKind kind = 2;
 * @return {!proto.pangolin.protos.SchedulePolicyKind}
 */
proto.pangolin.protos.SchedulePolicyObject.prototype.getKind = function() {
  return /** @type {!proto.pangolin.protos.SchedulePolicyKind} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.pangolin.protos.SchedulePolicyKind} value
 * @return {!proto.pangolin.protos.SchedulePolicyObject} returns this
 */
proto.pangolin.protos.SchedulePolicyObject.prototype.setKind = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.SchedulePolicyObject} returns this
 */
proto.pangolin.protos.SchedulePolicyObject.prototype.clearKind = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.SchedulePolicyObject.prototype.hasKind = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional SchedulePolicyCategory category = 3;
 * @return {!proto.pangolin.protos.SchedulePolicyCategory}
 */
proto.pangolin.protos.SchedulePolicyObject.prototype.getCategory = function() {
  return /** @type {!proto.pangolin.protos.SchedulePolicyCategory} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.pangolin.protos.SchedulePolicyCategory} value
 * @return {!proto.pangolin.protos.SchedulePolicyObject} returns this
 */
proto.pangolin.protos.SchedulePolicyObject.prototype.setCategory = function(value) {
  return jspb.Message.setOneofField(this, 3, proto.pangolin.protos.SchedulePolicyObject.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.SchedulePolicyObject} returns this
 */
proto.pangolin.protos.SchedulePolicyObject.prototype.clearCategory = function() {
  return jspb.Message.setOneofField(this, 3, proto.pangolin.protos.SchedulePolicyObject.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.SchedulePolicyObject.prototype.hasCategory = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string custom = 4;
 * @return {string}
 */
proto.pangolin.protos.SchedulePolicyObject.prototype.getCustom = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.SchedulePolicyObject} returns this
 */
proto.pangolin.protos.SchedulePolicyObject.prototype.setCustom = function(value) {
  return jspb.Message.setOneofField(this, 4, proto.pangolin.protos.SchedulePolicyObject.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.SchedulePolicyObject} returns this
 */
proto.pangolin.protos.SchedulePolicyObject.prototype.clearCustom = function() {
  return jspb.Message.setOneofField(this, 4, proto.pangolin.protos.SchedulePolicyObject.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.SchedulePolicyObject.prototype.hasCustom = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pangolin.protos.SchedulePolicyObjectMap.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.SchedulePolicyObjectMap.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.SchedulePolicyObjectMap.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.SchedulePolicyObjectMap} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.SchedulePolicyObjectMap.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.pangolin.protos.SchedulePolicyObjectMapTuple.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.SchedulePolicyObjectMap}
 */
proto.pangolin.protos.SchedulePolicyObjectMap.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.SchedulePolicyObjectMap;
  return proto.pangolin.protos.SchedulePolicyObjectMap.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.SchedulePolicyObjectMap} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.SchedulePolicyObjectMap}
 */
proto.pangolin.protos.SchedulePolicyObjectMap.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.SchedulePolicyObjectMapTuple;
      reader.readMessage(value,proto.pangolin.protos.SchedulePolicyObjectMapTuple.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.SchedulePolicyObjectMap.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.SchedulePolicyObjectMap.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.SchedulePolicyObjectMap} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.SchedulePolicyObjectMap.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.pangolin.protos.SchedulePolicyObjectMapTuple.serializeBinaryToWriter
    );
  }
};


/**
 * repeated SchedulePolicyObjectMapTuple items = 1;
 * @return {!Array<!proto.pangolin.protos.SchedulePolicyObjectMapTuple>}
 */
proto.pangolin.protos.SchedulePolicyObjectMap.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.pangolin.protos.SchedulePolicyObjectMapTuple>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.pangolin.protos.SchedulePolicyObjectMapTuple, 1));
};


/**
 * @param {!Array<!proto.pangolin.protos.SchedulePolicyObjectMapTuple>} value
 * @return {!proto.pangolin.protos.SchedulePolicyObjectMap} returns this
*/
proto.pangolin.protos.SchedulePolicyObjectMap.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.pangolin.protos.SchedulePolicyObjectMapTuple=} opt_value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.SchedulePolicyObjectMapTuple}
 */
proto.pangolin.protos.SchedulePolicyObjectMap.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.pangolin.protos.SchedulePolicyObjectMapTuple, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.SchedulePolicyObjectMap} returns this
 */
proto.pangolin.protos.SchedulePolicyObjectMap.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.SchedulePolicyObjectMapTuple.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.SchedulePolicyObjectMapTuple.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.SchedulePolicyObjectMapTuple} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.SchedulePolicyObjectMapTuple.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    data: (f = msg.getData()) && proto.pangolin.protos.SchedulePolicyObject.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.SchedulePolicyObjectMapTuple}
 */
proto.pangolin.protos.SchedulePolicyObjectMapTuple.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.SchedulePolicyObjectMapTuple;
  return proto.pangolin.protos.SchedulePolicyObjectMapTuple.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.SchedulePolicyObjectMapTuple} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.SchedulePolicyObjectMapTuple}
 */
proto.pangolin.protos.SchedulePolicyObjectMapTuple.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new proto.pangolin.protos.SchedulePolicyObject;
      reader.readMessage(value,proto.pangolin.protos.SchedulePolicyObject.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.SchedulePolicyObjectMapTuple.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.SchedulePolicyObjectMapTuple.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.SchedulePolicyObjectMapTuple} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.SchedulePolicyObjectMapTuple.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.pangolin.protos.SchedulePolicyObject.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.pangolin.protos.SchedulePolicyObjectMapTuple.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.SchedulePolicyObjectMapTuple} returns this
 */
proto.pangolin.protos.SchedulePolicyObjectMapTuple.prototype.setId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.SchedulePolicyObjectMapTuple} returns this
 */
proto.pangolin.protos.SchedulePolicyObjectMapTuple.prototype.clearId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.SchedulePolicyObjectMapTuple.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional SchedulePolicyObject data = 2;
 * @return {?proto.pangolin.protos.SchedulePolicyObject}
 */
proto.pangolin.protos.SchedulePolicyObjectMapTuple.prototype.getData = function() {
  return /** @type{?proto.pangolin.protos.SchedulePolicyObject} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.SchedulePolicyObject, 2));
};


/**
 * @param {?proto.pangolin.protos.SchedulePolicyObject|undefined} value
 * @return {!proto.pangolin.protos.SchedulePolicyObjectMapTuple} returns this
*/
proto.pangolin.protos.SchedulePolicyObjectMapTuple.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pangolin.protos.SchedulePolicyObjectMapTuple} returns this
 */
proto.pangolin.protos.SchedulePolicyObjectMapTuple.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.SchedulePolicyObjectMapTuple.prototype.hasData = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.ScheduleObject.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.ScheduleObject.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.ScheduleObject} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.ScheduleObject.toObject = function(includeInstance, msg) {
  var f, obj = {
    uuid: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    name: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
    enabled: (f = jspb.Message.getBooleanField(msg, 3)) == null ? undefined : f,
    start: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f,
    end: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f,
    hostAll: (f = jspb.Message.getBooleanField(msg, 6)) == null ? undefined : f,
    policyAll: (f = jspb.Message.getBooleanField(msg, 7)) == null ? undefined : f,
    days: (f = msg.getDays()) && proto.pangolin.protos.ScheduleDayFlag.toObject(includeInstance, f),
    hosts: (f = msg.getHosts()) && proto.pangolin.protos.ScheduleHostIdList.toObject(includeInstance, f),
    policies: (f = msg.getPolicies()) && proto.pangolin.protos.SchedulePolicyObjectMap.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.ScheduleObject}
 */
proto.pangolin.protos.ScheduleObject.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.ScheduleObject;
  return proto.pangolin.protos.ScheduleObject.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.ScheduleObject} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.ScheduleObject}
 */
proto.pangolin.protos.ScheduleObject.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnabled(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setStart(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setEnd(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHostAll(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPolicyAll(value);
      break;
    case 8:
      var value = new proto.pangolin.protos.ScheduleDayFlag;
      reader.readMessage(value,proto.pangolin.protos.ScheduleDayFlag.deserializeBinaryFromReader);
      msg.setDays(value);
      break;
    case 9:
      var value = new proto.pangolin.protos.ScheduleHostIdList;
      reader.readMessage(value,proto.pangolin.protos.ScheduleHostIdList.deserializeBinaryFromReader);
      msg.setHosts(value);
      break;
    case 10:
      var value = new proto.pangolin.protos.SchedulePolicyObjectMap;
      reader.readMessage(value,proto.pangolin.protos.SchedulePolicyObjectMap.deserializeBinaryFromReader);
      msg.setPolicies(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.ScheduleObject.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.ScheduleObject.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.ScheduleObject} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.ScheduleObject.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeBool(
      3,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeString(
      4,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeString(
      5,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeBool(
      6,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getDays();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.pangolin.protos.ScheduleDayFlag.serializeBinaryToWriter
    );
  }
  f = message.getHosts();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.pangolin.protos.ScheduleHostIdList.serializeBinaryToWriter
    );
  }
  f = message.getPolicies();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.pangolin.protos.SchedulePolicyObjectMap.serializeBinaryToWriter
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.pangolin.protos.ScheduleObject.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.ScheduleObject} returns this
 */
proto.pangolin.protos.ScheduleObject.prototype.setUuid = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.ScheduleObject} returns this
 */
proto.pangolin.protos.ScheduleObject.prototype.clearUuid = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.ScheduleObject.prototype.hasUuid = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.pangolin.protos.ScheduleObject.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.ScheduleObject} returns this
 */
proto.pangolin.protos.ScheduleObject.prototype.setName = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.ScheduleObject} returns this
 */
proto.pangolin.protos.ScheduleObject.prototype.clearName = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.ScheduleObject.prototype.hasName = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional bool enabled = 3;
 * @return {boolean}
 */
proto.pangolin.protos.ScheduleObject.prototype.getEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pangolin.protos.ScheduleObject} returns this
 */
proto.pangolin.protos.ScheduleObject.prototype.setEnabled = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.ScheduleObject} returns this
 */
proto.pangolin.protos.ScheduleObject.prototype.clearEnabled = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.ScheduleObject.prototype.hasEnabled = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string start = 4;
 * @return {string}
 */
proto.pangolin.protos.ScheduleObject.prototype.getStart = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.ScheduleObject} returns this
 */
proto.pangolin.protos.ScheduleObject.prototype.setStart = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.ScheduleObject} returns this
 */
proto.pangolin.protos.ScheduleObject.prototype.clearStart = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.ScheduleObject.prototype.hasStart = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional string end = 5;
 * @return {string}
 */
proto.pangolin.protos.ScheduleObject.prototype.getEnd = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.ScheduleObject} returns this
 */
proto.pangolin.protos.ScheduleObject.prototype.setEnd = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.ScheduleObject} returns this
 */
proto.pangolin.protos.ScheduleObject.prototype.clearEnd = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.ScheduleObject.prototype.hasEnd = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional bool host_all = 6;
 * @return {boolean}
 */
proto.pangolin.protos.ScheduleObject.prototype.getHostAll = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pangolin.protos.ScheduleObject} returns this
 */
proto.pangolin.protos.ScheduleObject.prototype.setHostAll = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.ScheduleObject} returns this
 */
proto.pangolin.protos.ScheduleObject.prototype.clearHostAll = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.ScheduleObject.prototype.hasHostAll = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional bool policy_all = 7;
 * @return {boolean}
 */
proto.pangolin.protos.ScheduleObject.prototype.getPolicyAll = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pangolin.protos.ScheduleObject} returns this
 */
proto.pangolin.protos.ScheduleObject.prototype.setPolicyAll = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.ScheduleObject} returns this
 */
proto.pangolin.protos.ScheduleObject.prototype.clearPolicyAll = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.ScheduleObject.prototype.hasPolicyAll = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional ScheduleDayFlag days = 8;
 * @return {?proto.pangolin.protos.ScheduleDayFlag}
 */
proto.pangolin.protos.ScheduleObject.prototype.getDays = function() {
  return /** @type{?proto.pangolin.protos.ScheduleDayFlag} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.ScheduleDayFlag, 8));
};


/**
 * @param {?proto.pangolin.protos.ScheduleDayFlag|undefined} value
 * @return {!proto.pangolin.protos.ScheduleObject} returns this
*/
proto.pangolin.protos.ScheduleObject.prototype.setDays = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pangolin.protos.ScheduleObject} returns this
 */
proto.pangolin.protos.ScheduleObject.prototype.clearDays = function() {
  return this.setDays(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.ScheduleObject.prototype.hasDays = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional ScheduleHostIdList hosts = 9;
 * @return {?proto.pangolin.protos.ScheduleHostIdList}
 */
proto.pangolin.protos.ScheduleObject.prototype.getHosts = function() {
  return /** @type{?proto.pangolin.protos.ScheduleHostIdList} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.ScheduleHostIdList, 9));
};


/**
 * @param {?proto.pangolin.protos.ScheduleHostIdList|undefined} value
 * @return {!proto.pangolin.protos.ScheduleObject} returns this
*/
proto.pangolin.protos.ScheduleObject.prototype.setHosts = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pangolin.protos.ScheduleObject} returns this
 */
proto.pangolin.protos.ScheduleObject.prototype.clearHosts = function() {
  return this.setHosts(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.ScheduleObject.prototype.hasHosts = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional SchedulePolicyObjectMap policies = 10;
 * @return {?proto.pangolin.protos.SchedulePolicyObjectMap}
 */
proto.pangolin.protos.ScheduleObject.prototype.getPolicies = function() {
  return /** @type{?proto.pangolin.protos.SchedulePolicyObjectMap} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.SchedulePolicyObjectMap, 10));
};


/**
 * @param {?proto.pangolin.protos.SchedulePolicyObjectMap|undefined} value
 * @return {!proto.pangolin.protos.ScheduleObject} returns this
*/
proto.pangolin.protos.ScheduleObject.prototype.setPolicies = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pangolin.protos.ScheduleObject} returns this
 */
proto.pangolin.protos.ScheduleObject.prototype.clearPolicies = function() {
  return this.setPolicies(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.ScheduleObject.prototype.hasPolicies = function() {
  return jspb.Message.getField(this, 10) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pangolin.protos.ScheduleObjectMap.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.ScheduleObjectMap.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.ScheduleObjectMap.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.ScheduleObjectMap} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.ScheduleObjectMap.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.pangolin.protos.ScheduleObjectMapTuple.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.ScheduleObjectMap}
 */
proto.pangolin.protos.ScheduleObjectMap.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.ScheduleObjectMap;
  return proto.pangolin.protos.ScheduleObjectMap.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.ScheduleObjectMap} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.ScheduleObjectMap}
 */
proto.pangolin.protos.ScheduleObjectMap.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.ScheduleObjectMapTuple;
      reader.readMessage(value,proto.pangolin.protos.ScheduleObjectMapTuple.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.ScheduleObjectMap.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.ScheduleObjectMap.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.ScheduleObjectMap} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.ScheduleObjectMap.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.pangolin.protos.ScheduleObjectMapTuple.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ScheduleObjectMapTuple items = 1;
 * @return {!Array<!proto.pangolin.protos.ScheduleObjectMapTuple>}
 */
proto.pangolin.protos.ScheduleObjectMap.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.pangolin.protos.ScheduleObjectMapTuple>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.pangolin.protos.ScheduleObjectMapTuple, 1));
};


/**
 * @param {!Array<!proto.pangolin.protos.ScheduleObjectMapTuple>} value
 * @return {!proto.pangolin.protos.ScheduleObjectMap} returns this
*/
proto.pangolin.protos.ScheduleObjectMap.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.pangolin.protos.ScheduleObjectMapTuple=} opt_value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.ScheduleObjectMapTuple}
 */
proto.pangolin.protos.ScheduleObjectMap.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.pangolin.protos.ScheduleObjectMapTuple, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.ScheduleObjectMap} returns this
 */
proto.pangolin.protos.ScheduleObjectMap.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.ScheduleObjectMapTuple.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.ScheduleObjectMapTuple.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.ScheduleObjectMapTuple} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.ScheduleObjectMapTuple.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    data: (f = msg.getData()) && proto.pangolin.protos.ScheduleObject.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.ScheduleObjectMapTuple}
 */
proto.pangolin.protos.ScheduleObjectMapTuple.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.ScheduleObjectMapTuple;
  return proto.pangolin.protos.ScheduleObjectMapTuple.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.ScheduleObjectMapTuple} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.ScheduleObjectMapTuple}
 */
proto.pangolin.protos.ScheduleObjectMapTuple.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new proto.pangolin.protos.ScheduleObject;
      reader.readMessage(value,proto.pangolin.protos.ScheduleObject.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.ScheduleObjectMapTuple.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.ScheduleObjectMapTuple.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.ScheduleObjectMapTuple} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.ScheduleObjectMapTuple.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.pangolin.protos.ScheduleObject.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.pangolin.protos.ScheduleObjectMapTuple.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.ScheduleObjectMapTuple} returns this
 */
proto.pangolin.protos.ScheduleObjectMapTuple.prototype.setId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.ScheduleObjectMapTuple} returns this
 */
proto.pangolin.protos.ScheduleObjectMapTuple.prototype.clearId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.ScheduleObjectMapTuple.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional ScheduleObject data = 2;
 * @return {?proto.pangolin.protos.ScheduleObject}
 */
proto.pangolin.protos.ScheduleObjectMapTuple.prototype.getData = function() {
  return /** @type{?proto.pangolin.protos.ScheduleObject} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.ScheduleObject, 2));
};


/**
 * @param {?proto.pangolin.protos.ScheduleObject|undefined} value
 * @return {!proto.pangolin.protos.ScheduleObjectMapTuple} returns this
*/
proto.pangolin.protos.ScheduleObjectMapTuple.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pangolin.protos.ScheduleObjectMapTuple} returns this
 */
proto.pangolin.protos.ScheduleObjectMapTuple.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.ScheduleObjectMapTuple.prototype.hasData = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pangolin.protos.ScheduleHostErrorMap.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.ScheduleHostErrorMap.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.ScheduleHostErrorMap.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.ScheduleHostErrorMap} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.ScheduleHostErrorMap.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.pangolin.protos.ScheduleHostErrorMapTuple.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.ScheduleHostErrorMap}
 */
proto.pangolin.protos.ScheduleHostErrorMap.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.ScheduleHostErrorMap;
  return proto.pangolin.protos.ScheduleHostErrorMap.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.ScheduleHostErrorMap} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.ScheduleHostErrorMap}
 */
proto.pangolin.protos.ScheduleHostErrorMap.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.ScheduleHostErrorMapTuple;
      reader.readMessage(value,proto.pangolin.protos.ScheduleHostErrorMapTuple.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.ScheduleHostErrorMap.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.ScheduleHostErrorMap.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.ScheduleHostErrorMap} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.ScheduleHostErrorMap.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.pangolin.protos.ScheduleHostErrorMapTuple.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ScheduleHostErrorMapTuple items = 1;
 * @return {!Array<!proto.pangolin.protos.ScheduleHostErrorMapTuple>}
 */
proto.pangolin.protos.ScheduleHostErrorMap.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.pangolin.protos.ScheduleHostErrorMapTuple>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.pangolin.protos.ScheduleHostErrorMapTuple, 1));
};


/**
 * @param {!Array<!proto.pangolin.protos.ScheduleHostErrorMapTuple>} value
 * @return {!proto.pangolin.protos.ScheduleHostErrorMap} returns this
*/
proto.pangolin.protos.ScheduleHostErrorMap.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.pangolin.protos.ScheduleHostErrorMapTuple=} opt_value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.ScheduleHostErrorMapTuple}
 */
proto.pangolin.protos.ScheduleHostErrorMap.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.pangolin.protos.ScheduleHostErrorMapTuple, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.ScheduleHostErrorMap} returns this
 */
proto.pangolin.protos.ScheduleHostErrorMap.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pangolin.protos.ScheduleHostErrorMapTuple.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.ScheduleHostErrorMapTuple.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.ScheduleHostErrorMapTuple.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.ScheduleHostErrorMapTuple} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.ScheduleHostErrorMapTuple.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    errorList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.ScheduleHostErrorMapTuple}
 */
proto.pangolin.protos.ScheduleHostErrorMapTuple.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.ScheduleHostErrorMapTuple;
  return proto.pangolin.protos.ScheduleHostErrorMapTuple.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.ScheduleHostErrorMapTuple} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.ScheduleHostErrorMapTuple}
 */
proto.pangolin.protos.ScheduleHostErrorMapTuple.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.ScheduleHostErrorMapTuple.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.ScheduleHostErrorMapTuple.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.ScheduleHostErrorMapTuple} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.ScheduleHostErrorMapTuple.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getErrorList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.pangolin.protos.ScheduleHostErrorMapTuple.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.ScheduleHostErrorMapTuple} returns this
 */
proto.pangolin.protos.ScheduleHostErrorMapTuple.prototype.setId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.ScheduleHostErrorMapTuple} returns this
 */
proto.pangolin.protos.ScheduleHostErrorMapTuple.prototype.clearId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.ScheduleHostErrorMapTuple.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated string error = 2;
 * @return {!Array<string>}
 */
proto.pangolin.protos.ScheduleHostErrorMapTuple.prototype.getErrorList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pangolin.protos.ScheduleHostErrorMapTuple} returns this
 */
proto.pangolin.protos.ScheduleHostErrorMapTuple.prototype.setErrorList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.ScheduleHostErrorMapTuple} returns this
 */
proto.pangolin.protos.ScheduleHostErrorMapTuple.prototype.addError = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.ScheduleHostErrorMapTuple} returns this
 */
proto.pangolin.protos.ScheduleHostErrorMapTuple.prototype.clearErrorList = function() {
  return this.setErrorList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pangolin.protos.SchedulePolicyError.repeatedFields_ = [1,2,3,4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.SchedulePolicyError.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.SchedulePolicyError.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.SchedulePolicyError} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.SchedulePolicyError.toObject = function(includeInstance, msg) {
  var f, obj = {
    uuidList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    kindList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    categoryList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
    customList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.SchedulePolicyError}
 */
proto.pangolin.protos.SchedulePolicyError.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.SchedulePolicyError;
  return proto.pangolin.protos.SchedulePolicyError.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.SchedulePolicyError} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.SchedulePolicyError}
 */
proto.pangolin.protos.SchedulePolicyError.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addUuid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addKind(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addCategory(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.addCustom(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.SchedulePolicyError.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.SchedulePolicyError.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.SchedulePolicyError} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.SchedulePolicyError.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuidList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getKindList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
  f = message.getCategoryList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getCustomList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
};


/**
 * repeated string uuid = 1;
 * @return {!Array<string>}
 */
proto.pangolin.protos.SchedulePolicyError.prototype.getUuidList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pangolin.protos.SchedulePolicyError} returns this
 */
proto.pangolin.protos.SchedulePolicyError.prototype.setUuidList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.SchedulePolicyError} returns this
 */
proto.pangolin.protos.SchedulePolicyError.prototype.addUuid = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.SchedulePolicyError} returns this
 */
proto.pangolin.protos.SchedulePolicyError.prototype.clearUuidList = function() {
  return this.setUuidList([]);
};


/**
 * repeated string kind = 2;
 * @return {!Array<string>}
 */
proto.pangolin.protos.SchedulePolicyError.prototype.getKindList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pangolin.protos.SchedulePolicyError} returns this
 */
proto.pangolin.protos.SchedulePolicyError.prototype.setKindList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.SchedulePolicyError} returns this
 */
proto.pangolin.protos.SchedulePolicyError.prototype.addKind = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.SchedulePolicyError} returns this
 */
proto.pangolin.protos.SchedulePolicyError.prototype.clearKindList = function() {
  return this.setKindList([]);
};


/**
 * repeated string category = 3;
 * @return {!Array<string>}
 */
proto.pangolin.protos.SchedulePolicyError.prototype.getCategoryList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pangolin.protos.SchedulePolicyError} returns this
 */
proto.pangolin.protos.SchedulePolicyError.prototype.setCategoryList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.SchedulePolicyError} returns this
 */
proto.pangolin.protos.SchedulePolicyError.prototype.addCategory = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.SchedulePolicyError} returns this
 */
proto.pangolin.protos.SchedulePolicyError.prototype.clearCategoryList = function() {
  return this.setCategoryList([]);
};


/**
 * repeated string custom = 4;
 * @return {!Array<string>}
 */
proto.pangolin.protos.SchedulePolicyError.prototype.getCustomList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pangolin.protos.SchedulePolicyError} returns this
 */
proto.pangolin.protos.SchedulePolicyError.prototype.setCustomList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.SchedulePolicyError} returns this
 */
proto.pangolin.protos.SchedulePolicyError.prototype.addCustom = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.SchedulePolicyError} returns this
 */
proto.pangolin.protos.SchedulePolicyError.prototype.clearCustomList = function() {
  return this.setCustomList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pangolin.protos.SchedulePolicyErrorMap.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.SchedulePolicyErrorMap.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.SchedulePolicyErrorMap.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.SchedulePolicyErrorMap} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.SchedulePolicyErrorMap.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.pangolin.protos.SchedulePolicyErrorMapTuple.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.SchedulePolicyErrorMap}
 */
proto.pangolin.protos.SchedulePolicyErrorMap.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.SchedulePolicyErrorMap;
  return proto.pangolin.protos.SchedulePolicyErrorMap.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.SchedulePolicyErrorMap} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.SchedulePolicyErrorMap}
 */
proto.pangolin.protos.SchedulePolicyErrorMap.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.SchedulePolicyErrorMapTuple;
      reader.readMessage(value,proto.pangolin.protos.SchedulePolicyErrorMapTuple.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.SchedulePolicyErrorMap.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.SchedulePolicyErrorMap.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.SchedulePolicyErrorMap} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.SchedulePolicyErrorMap.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.pangolin.protos.SchedulePolicyErrorMapTuple.serializeBinaryToWriter
    );
  }
};


/**
 * repeated SchedulePolicyErrorMapTuple items = 1;
 * @return {!Array<!proto.pangolin.protos.SchedulePolicyErrorMapTuple>}
 */
proto.pangolin.protos.SchedulePolicyErrorMap.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.pangolin.protos.SchedulePolicyErrorMapTuple>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.pangolin.protos.SchedulePolicyErrorMapTuple, 1));
};


/**
 * @param {!Array<!proto.pangolin.protos.SchedulePolicyErrorMapTuple>} value
 * @return {!proto.pangolin.protos.SchedulePolicyErrorMap} returns this
*/
proto.pangolin.protos.SchedulePolicyErrorMap.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.pangolin.protos.SchedulePolicyErrorMapTuple=} opt_value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.SchedulePolicyErrorMapTuple}
 */
proto.pangolin.protos.SchedulePolicyErrorMap.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.pangolin.protos.SchedulePolicyErrorMapTuple, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.SchedulePolicyErrorMap} returns this
 */
proto.pangolin.protos.SchedulePolicyErrorMap.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.SchedulePolicyErrorMapTuple.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.SchedulePolicyErrorMapTuple.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.SchedulePolicyErrorMapTuple} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.SchedulePolicyErrorMapTuple.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    error: (f = msg.getError()) && proto.pangolin.protos.SchedulePolicyError.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.SchedulePolicyErrorMapTuple}
 */
proto.pangolin.protos.SchedulePolicyErrorMapTuple.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.SchedulePolicyErrorMapTuple;
  return proto.pangolin.protos.SchedulePolicyErrorMapTuple.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.SchedulePolicyErrorMapTuple} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.SchedulePolicyErrorMapTuple}
 */
proto.pangolin.protos.SchedulePolicyErrorMapTuple.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new proto.pangolin.protos.SchedulePolicyError;
      reader.readMessage(value,proto.pangolin.protos.SchedulePolicyError.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.SchedulePolicyErrorMapTuple.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.SchedulePolicyErrorMapTuple.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.SchedulePolicyErrorMapTuple} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.SchedulePolicyErrorMapTuple.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.pangolin.protos.SchedulePolicyError.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.pangolin.protos.SchedulePolicyErrorMapTuple.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.SchedulePolicyErrorMapTuple} returns this
 */
proto.pangolin.protos.SchedulePolicyErrorMapTuple.prototype.setId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.SchedulePolicyErrorMapTuple} returns this
 */
proto.pangolin.protos.SchedulePolicyErrorMapTuple.prototype.clearId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.SchedulePolicyErrorMapTuple.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional SchedulePolicyError error = 2;
 * @return {?proto.pangolin.protos.SchedulePolicyError}
 */
proto.pangolin.protos.SchedulePolicyErrorMapTuple.prototype.getError = function() {
  return /** @type{?proto.pangolin.protos.SchedulePolicyError} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.SchedulePolicyError, 2));
};


/**
 * @param {?proto.pangolin.protos.SchedulePolicyError|undefined} value
 * @return {!proto.pangolin.protos.SchedulePolicyErrorMapTuple} returns this
*/
proto.pangolin.protos.SchedulePolicyErrorMapTuple.prototype.setError = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pangolin.protos.SchedulePolicyErrorMapTuple} returns this
 */
proto.pangolin.protos.SchedulePolicyErrorMapTuple.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.SchedulePolicyErrorMapTuple.prototype.hasError = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pangolin.protos.ScheduleError.repeatedFields_ = [1,2,3,4,5,6,7,8];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.ScheduleError.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.ScheduleError.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.ScheduleError} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.ScheduleError.toObject = function(includeInstance, msg) {
  var f, obj = {
    uuidList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    nameList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    enabledList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
    startList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f,
    endList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f,
    hostAllList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f,
    policyAllList: (f = jspb.Message.getRepeatedField(msg, 7)) == null ? undefined : f,
    daysList: (f = jspb.Message.getRepeatedField(msg, 8)) == null ? undefined : f,
    hosts: (f = msg.getHosts()) && proto.pangolin.protos.ScheduleHostErrorMap.toObject(includeInstance, f),
    policies: (f = msg.getPolicies()) && proto.pangolin.protos.SchedulePolicyErrorMap.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.ScheduleError}
 */
proto.pangolin.protos.ScheduleError.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.ScheduleError;
  return proto.pangolin.protos.ScheduleError.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.ScheduleError} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.ScheduleError}
 */
proto.pangolin.protos.ScheduleError.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addUuid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addEnabled(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.addStart(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.addEnd(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.addHostAll(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.addPolicyAll(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.addDays(value);
      break;
    case 9:
      var value = new proto.pangolin.protos.ScheduleHostErrorMap;
      reader.readMessage(value,proto.pangolin.protos.ScheduleHostErrorMap.deserializeBinaryFromReader);
      msg.setHosts(value);
      break;
    case 10:
      var value = new proto.pangolin.protos.SchedulePolicyErrorMap;
      reader.readMessage(value,proto.pangolin.protos.SchedulePolicyErrorMap.deserializeBinaryFromReader);
      msg.setPolicies(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.ScheduleError.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.ScheduleError.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.ScheduleError} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.ScheduleError.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuidList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getNameList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
  f = message.getEnabledList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getStartList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
  f = message.getEndList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      5,
      f
    );
  }
  f = message.getHostAllList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      6,
      f
    );
  }
  f = message.getPolicyAllList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      7,
      f
    );
  }
  f = message.getDaysList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      8,
      f
    );
  }
  f = message.getHosts();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.pangolin.protos.ScheduleHostErrorMap.serializeBinaryToWriter
    );
  }
  f = message.getPolicies();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.pangolin.protos.SchedulePolicyErrorMap.serializeBinaryToWriter
    );
  }
};


/**
 * repeated string uuid = 1;
 * @return {!Array<string>}
 */
proto.pangolin.protos.ScheduleError.prototype.getUuidList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pangolin.protos.ScheduleError} returns this
 */
proto.pangolin.protos.ScheduleError.prototype.setUuidList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.ScheduleError} returns this
 */
proto.pangolin.protos.ScheduleError.prototype.addUuid = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.ScheduleError} returns this
 */
proto.pangolin.protos.ScheduleError.prototype.clearUuidList = function() {
  return this.setUuidList([]);
};


/**
 * repeated string name = 2;
 * @return {!Array<string>}
 */
proto.pangolin.protos.ScheduleError.prototype.getNameList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pangolin.protos.ScheduleError} returns this
 */
proto.pangolin.protos.ScheduleError.prototype.setNameList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.ScheduleError} returns this
 */
proto.pangolin.protos.ScheduleError.prototype.addName = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.ScheduleError} returns this
 */
proto.pangolin.protos.ScheduleError.prototype.clearNameList = function() {
  return this.setNameList([]);
};


/**
 * repeated string enabled = 3;
 * @return {!Array<string>}
 */
proto.pangolin.protos.ScheduleError.prototype.getEnabledList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pangolin.protos.ScheduleError} returns this
 */
proto.pangolin.protos.ScheduleError.prototype.setEnabledList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.ScheduleError} returns this
 */
proto.pangolin.protos.ScheduleError.prototype.addEnabled = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.ScheduleError} returns this
 */
proto.pangolin.protos.ScheduleError.prototype.clearEnabledList = function() {
  return this.setEnabledList([]);
};


/**
 * repeated string start = 4;
 * @return {!Array<string>}
 */
proto.pangolin.protos.ScheduleError.prototype.getStartList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pangolin.protos.ScheduleError} returns this
 */
proto.pangolin.protos.ScheduleError.prototype.setStartList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.ScheduleError} returns this
 */
proto.pangolin.protos.ScheduleError.prototype.addStart = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.ScheduleError} returns this
 */
proto.pangolin.protos.ScheduleError.prototype.clearStartList = function() {
  return this.setStartList([]);
};


/**
 * repeated string end = 5;
 * @return {!Array<string>}
 */
proto.pangolin.protos.ScheduleError.prototype.getEndList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pangolin.protos.ScheduleError} returns this
 */
proto.pangolin.protos.ScheduleError.prototype.setEndList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.ScheduleError} returns this
 */
proto.pangolin.protos.ScheduleError.prototype.addEnd = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.ScheduleError} returns this
 */
proto.pangolin.protos.ScheduleError.prototype.clearEndList = function() {
  return this.setEndList([]);
};


/**
 * repeated string host_all = 6;
 * @return {!Array<string>}
 */
proto.pangolin.protos.ScheduleError.prototype.getHostAllList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 6));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pangolin.protos.ScheduleError} returns this
 */
proto.pangolin.protos.ScheduleError.prototype.setHostAllList = function(value) {
  return jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.ScheduleError} returns this
 */
proto.pangolin.protos.ScheduleError.prototype.addHostAll = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.ScheduleError} returns this
 */
proto.pangolin.protos.ScheduleError.prototype.clearHostAllList = function() {
  return this.setHostAllList([]);
};


/**
 * repeated string policy_all = 7;
 * @return {!Array<string>}
 */
proto.pangolin.protos.ScheduleError.prototype.getPolicyAllList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 7));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pangolin.protos.ScheduleError} returns this
 */
proto.pangolin.protos.ScheduleError.prototype.setPolicyAllList = function(value) {
  return jspb.Message.setField(this, 7, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.ScheduleError} returns this
 */
proto.pangolin.protos.ScheduleError.prototype.addPolicyAll = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 7, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.ScheduleError} returns this
 */
proto.pangolin.protos.ScheduleError.prototype.clearPolicyAllList = function() {
  return this.setPolicyAllList([]);
};


/**
 * repeated string days = 8;
 * @return {!Array<string>}
 */
proto.pangolin.protos.ScheduleError.prototype.getDaysList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 8));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.pangolin.protos.ScheduleError} returns this
 */
proto.pangolin.protos.ScheduleError.prototype.setDaysList = function(value) {
  return jspb.Message.setField(this, 8, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.ScheduleError} returns this
 */
proto.pangolin.protos.ScheduleError.prototype.addDays = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 8, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.ScheduleError} returns this
 */
proto.pangolin.protos.ScheduleError.prototype.clearDaysList = function() {
  return this.setDaysList([]);
};


/**
 * optional ScheduleHostErrorMap hosts = 9;
 * @return {?proto.pangolin.protos.ScheduleHostErrorMap}
 */
proto.pangolin.protos.ScheduleError.prototype.getHosts = function() {
  return /** @type{?proto.pangolin.protos.ScheduleHostErrorMap} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.ScheduleHostErrorMap, 9));
};


/**
 * @param {?proto.pangolin.protos.ScheduleHostErrorMap|undefined} value
 * @return {!proto.pangolin.protos.ScheduleError} returns this
*/
proto.pangolin.protos.ScheduleError.prototype.setHosts = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pangolin.protos.ScheduleError} returns this
 */
proto.pangolin.protos.ScheduleError.prototype.clearHosts = function() {
  return this.setHosts(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.ScheduleError.prototype.hasHosts = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional SchedulePolicyErrorMap policies = 10;
 * @return {?proto.pangolin.protos.SchedulePolicyErrorMap}
 */
proto.pangolin.protos.ScheduleError.prototype.getPolicies = function() {
  return /** @type{?proto.pangolin.protos.SchedulePolicyErrorMap} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.SchedulePolicyErrorMap, 10));
};


/**
 * @param {?proto.pangolin.protos.SchedulePolicyErrorMap|undefined} value
 * @return {!proto.pangolin.protos.ScheduleError} returns this
*/
proto.pangolin.protos.ScheduleError.prototype.setPolicies = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pangolin.protos.ScheduleError} returns this
 */
proto.pangolin.protos.ScheduleError.prototype.clearPolicies = function() {
  return this.setPolicies(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.ScheduleError.prototype.hasPolicies = function() {
  return jspb.Message.getField(this, 10) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pangolin.protos.ScheduleErrorMap.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.ScheduleErrorMap.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.ScheduleErrorMap.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.ScheduleErrorMap} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.ScheduleErrorMap.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.pangolin.protos.ScheduleErrorMapTuple.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.ScheduleErrorMap}
 */
proto.pangolin.protos.ScheduleErrorMap.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.ScheduleErrorMap;
  return proto.pangolin.protos.ScheduleErrorMap.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.ScheduleErrorMap} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.ScheduleErrorMap}
 */
proto.pangolin.protos.ScheduleErrorMap.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.ScheduleErrorMapTuple;
      reader.readMessage(value,proto.pangolin.protos.ScheduleErrorMapTuple.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.ScheduleErrorMap.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.ScheduleErrorMap.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.ScheduleErrorMap} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.ScheduleErrorMap.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.pangolin.protos.ScheduleErrorMapTuple.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ScheduleErrorMapTuple items = 1;
 * @return {!Array<!proto.pangolin.protos.ScheduleErrorMapTuple>}
 */
proto.pangolin.protos.ScheduleErrorMap.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.pangolin.protos.ScheduleErrorMapTuple>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.pangolin.protos.ScheduleErrorMapTuple, 1));
};


/**
 * @param {!Array<!proto.pangolin.protos.ScheduleErrorMapTuple>} value
 * @return {!proto.pangolin.protos.ScheduleErrorMap} returns this
*/
proto.pangolin.protos.ScheduleErrorMap.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.pangolin.protos.ScheduleErrorMapTuple=} opt_value
 * @param {number=} opt_index
 * @return {!proto.pangolin.protos.ScheduleErrorMapTuple}
 */
proto.pangolin.protos.ScheduleErrorMap.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.pangolin.protos.ScheduleErrorMapTuple, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pangolin.protos.ScheduleErrorMap} returns this
 */
proto.pangolin.protos.ScheduleErrorMap.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.ScheduleErrorMapTuple.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.ScheduleErrorMapTuple.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.ScheduleErrorMapTuple} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.ScheduleErrorMapTuple.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
    error: (f = msg.getError()) && proto.pangolin.protos.ScheduleError.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.ScheduleErrorMapTuple}
 */
proto.pangolin.protos.ScheduleErrorMapTuple.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.ScheduleErrorMapTuple;
  return proto.pangolin.protos.ScheduleErrorMapTuple.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.ScheduleErrorMapTuple} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.ScheduleErrorMapTuple}
 */
proto.pangolin.protos.ScheduleErrorMapTuple.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new proto.pangolin.protos.ScheduleError;
      reader.readMessage(value,proto.pangolin.protos.ScheduleError.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.ScheduleErrorMapTuple.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.ScheduleErrorMapTuple.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.ScheduleErrorMapTuple} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.ScheduleErrorMapTuple.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.pangolin.protos.ScheduleError.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.pangolin.protos.ScheduleErrorMapTuple.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pangolin.protos.ScheduleErrorMapTuple} returns this
 */
proto.pangolin.protos.ScheduleErrorMapTuple.prototype.setId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.ScheduleErrorMapTuple} returns this
 */
proto.pangolin.protos.ScheduleErrorMapTuple.prototype.clearId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.ScheduleErrorMapTuple.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional ScheduleError error = 2;
 * @return {?proto.pangolin.protos.ScheduleError}
 */
proto.pangolin.protos.ScheduleErrorMapTuple.prototype.getError = function() {
  return /** @type{?proto.pangolin.protos.ScheduleError} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.ScheduleError, 2));
};


/**
 * @param {?proto.pangolin.protos.ScheduleError|undefined} value
 * @return {!proto.pangolin.protos.ScheduleErrorMapTuple} returns this
*/
proto.pangolin.protos.ScheduleErrorMapTuple.prototype.setError = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pangolin.protos.ScheduleErrorMapTuple} returns this
 */
proto.pangolin.protos.ScheduleErrorMapTuple.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.ScheduleErrorMapTuple.prototype.hasError = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.GetSchedulesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.GetSchedulesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.GetSchedulesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.GetSchedulesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    schedules: (f = msg.getSchedules()) && proto.pangolin.protos.ScheduleObjectMap.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.GetSchedulesResponse}
 */
proto.pangolin.protos.GetSchedulesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.GetSchedulesResponse;
  return proto.pangolin.protos.GetSchedulesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.GetSchedulesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.GetSchedulesResponse}
 */
proto.pangolin.protos.GetSchedulesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.ScheduleObjectMap;
      reader.readMessage(value,proto.pangolin.protos.ScheduleObjectMap.deserializeBinaryFromReader);
      msg.setSchedules(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.GetSchedulesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.GetSchedulesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.GetSchedulesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.GetSchedulesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSchedules();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pangolin.protos.ScheduleObjectMap.serializeBinaryToWriter
    );
  }
};


/**
 * required ScheduleObjectMap schedules = 1;
 * @return {!proto.pangolin.protos.ScheduleObjectMap}
 */
proto.pangolin.protos.GetSchedulesResponse.prototype.getSchedules = function() {
  return /** @type{!proto.pangolin.protos.ScheduleObjectMap} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.ScheduleObjectMap, 1, 1));
};


/**
 * @param {!proto.pangolin.protos.ScheduleObjectMap} value
 * @return {!proto.pangolin.protos.GetSchedulesResponse} returns this
*/
proto.pangolin.protos.GetSchedulesResponse.prototype.setSchedules = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.GetSchedulesResponse} returns this
 */
proto.pangolin.protos.GetSchedulesResponse.prototype.clearSchedules = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.GetSchedulesResponse.prototype.hasSchedules = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.SetSchedulesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.SetSchedulesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.SetSchedulesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.SetSchedulesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    schedules: (f = msg.getSchedules()) && proto.pangolin.protos.ScheduleObjectMap.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.SetSchedulesRequest}
 */
proto.pangolin.protos.SetSchedulesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.SetSchedulesRequest;
  return proto.pangolin.protos.SetSchedulesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.SetSchedulesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.SetSchedulesRequest}
 */
proto.pangolin.protos.SetSchedulesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.ScheduleObjectMap;
      reader.readMessage(value,proto.pangolin.protos.ScheduleObjectMap.deserializeBinaryFromReader);
      msg.setSchedules(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.SetSchedulesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.SetSchedulesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.SetSchedulesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.SetSchedulesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSchedules();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pangolin.protos.ScheduleObjectMap.serializeBinaryToWriter
    );
  }
};


/**
 * required ScheduleObjectMap schedules = 1;
 * @return {!proto.pangolin.protos.ScheduleObjectMap}
 */
proto.pangolin.protos.SetSchedulesRequest.prototype.getSchedules = function() {
  return /** @type{!proto.pangolin.protos.ScheduleObjectMap} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.ScheduleObjectMap, 1, 1));
};


/**
 * @param {!proto.pangolin.protos.ScheduleObjectMap} value
 * @return {!proto.pangolin.protos.SetSchedulesRequest} returns this
*/
proto.pangolin.protos.SetSchedulesRequest.prototype.setSchedules = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.SetSchedulesRequest} returns this
 */
proto.pangolin.protos.SetSchedulesRequest.prototype.clearSchedules = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.SetSchedulesRequest.prototype.hasSchedules = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.SetSchedulesResponseInvalid.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.SetSchedulesResponseInvalid.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.SetSchedulesResponseInvalid} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.SetSchedulesResponseInvalid.toObject = function(includeInstance, msg) {
  var f, obj = {
    schedules: (f = msg.getSchedules()) && proto.pangolin.protos.ScheduleErrorMap.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.SetSchedulesResponseInvalid}
 */
proto.pangolin.protos.SetSchedulesResponseInvalid.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.SetSchedulesResponseInvalid;
  return proto.pangolin.protos.SetSchedulesResponseInvalid.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.SetSchedulesResponseInvalid} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.SetSchedulesResponseInvalid}
 */
proto.pangolin.protos.SetSchedulesResponseInvalid.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.ScheduleErrorMap;
      reader.readMessage(value,proto.pangolin.protos.ScheduleErrorMap.deserializeBinaryFromReader);
      msg.setSchedules(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.SetSchedulesResponseInvalid.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.SetSchedulesResponseInvalid.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.SetSchedulesResponseInvalid} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.SetSchedulesResponseInvalid.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSchedules();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pangolin.protos.ScheduleErrorMap.serializeBinaryToWriter
    );
  }
};


/**
 * required ScheduleErrorMap schedules = 1;
 * @return {!proto.pangolin.protos.ScheduleErrorMap}
 */
proto.pangolin.protos.SetSchedulesResponseInvalid.prototype.getSchedules = function() {
  return /** @type{!proto.pangolin.protos.ScheduleErrorMap} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.ScheduleErrorMap, 1, 1));
};


/**
 * @param {!proto.pangolin.protos.ScheduleErrorMap} value
 * @return {!proto.pangolin.protos.SetSchedulesResponseInvalid} returns this
*/
proto.pangolin.protos.SetSchedulesResponseInvalid.prototype.setSchedules = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.SetSchedulesResponseInvalid} returns this
 */
proto.pangolin.protos.SetSchedulesResponseInvalid.prototype.clearSchedules = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.SetSchedulesResponseInvalid.prototype.hasSchedules = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.GetScheduleResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.GetScheduleResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.GetScheduleResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.GetScheduleResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    schedule: (f = msg.getSchedule()) && proto.pangolin.protos.ScheduleObject.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.GetScheduleResponse}
 */
proto.pangolin.protos.GetScheduleResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.GetScheduleResponse;
  return proto.pangolin.protos.GetScheduleResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.GetScheduleResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.GetScheduleResponse}
 */
proto.pangolin.protos.GetScheduleResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.ScheduleObject;
      reader.readMessage(value,proto.pangolin.protos.ScheduleObject.deserializeBinaryFromReader);
      msg.setSchedule(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.GetScheduleResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.GetScheduleResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.GetScheduleResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.GetScheduleResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSchedule();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pangolin.protos.ScheduleObject.serializeBinaryToWriter
    );
  }
};


/**
 * required ScheduleObject schedule = 1;
 * @return {!proto.pangolin.protos.ScheduleObject}
 */
proto.pangolin.protos.GetScheduleResponse.prototype.getSchedule = function() {
  return /** @type{!proto.pangolin.protos.ScheduleObject} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.ScheduleObject, 1, 1));
};


/**
 * @param {!proto.pangolin.protos.ScheduleObject} value
 * @return {!proto.pangolin.protos.GetScheduleResponse} returns this
*/
proto.pangolin.protos.GetScheduleResponse.prototype.setSchedule = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.GetScheduleResponse} returns this
 */
proto.pangolin.protos.GetScheduleResponse.prototype.clearSchedule = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.GetScheduleResponse.prototype.hasSchedule = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.SetScheduleRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.SetScheduleRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.SetScheduleRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.SetScheduleRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    schedule: (f = msg.getSchedule()) && proto.pangolin.protos.ScheduleObject.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.SetScheduleRequest}
 */
proto.pangolin.protos.SetScheduleRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.SetScheduleRequest;
  return proto.pangolin.protos.SetScheduleRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.SetScheduleRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.SetScheduleRequest}
 */
proto.pangolin.protos.SetScheduleRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.ScheduleObject;
      reader.readMessage(value,proto.pangolin.protos.ScheduleObject.deserializeBinaryFromReader);
      msg.setSchedule(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.SetScheduleRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.SetScheduleRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.SetScheduleRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.SetScheduleRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSchedule();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pangolin.protos.ScheduleObject.serializeBinaryToWriter
    );
  }
};


/**
 * optional ScheduleObject schedule = 1;
 * @return {?proto.pangolin.protos.ScheduleObject}
 */
proto.pangolin.protos.SetScheduleRequest.prototype.getSchedule = function() {
  return /** @type{?proto.pangolin.protos.ScheduleObject} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.ScheduleObject, 1));
};


/**
 * @param {?proto.pangolin.protos.ScheduleObject|undefined} value
 * @return {!proto.pangolin.protos.SetScheduleRequest} returns this
*/
proto.pangolin.protos.SetScheduleRequest.prototype.setSchedule = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pangolin.protos.SetScheduleRequest} returns this
 */
proto.pangolin.protos.SetScheduleRequest.prototype.clearSchedule = function() {
  return this.setSchedule(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.SetScheduleRequest.prototype.hasSchedule = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.SetScheduleResponseInvalid.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.SetScheduleResponseInvalid.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.SetScheduleResponseInvalid} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.SetScheduleResponseInvalid.toObject = function(includeInstance, msg) {
  var f, obj = {
    schedule: (f = msg.getSchedule()) && proto.pangolin.protos.ScheduleError.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.SetScheduleResponseInvalid}
 */
proto.pangolin.protos.SetScheduleResponseInvalid.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.SetScheduleResponseInvalid;
  return proto.pangolin.protos.SetScheduleResponseInvalid.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.SetScheduleResponseInvalid} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.SetScheduleResponseInvalid}
 */
proto.pangolin.protos.SetScheduleResponseInvalid.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.ScheduleError;
      reader.readMessage(value,proto.pangolin.protos.ScheduleError.deserializeBinaryFromReader);
      msg.setSchedule(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.SetScheduleResponseInvalid.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.SetScheduleResponseInvalid.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.SetScheduleResponseInvalid} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.SetScheduleResponseInvalid.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSchedule();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pangolin.protos.ScheduleError.serializeBinaryToWriter
    );
  }
};


/**
 * optional ScheduleError schedule = 1;
 * @return {?proto.pangolin.protos.ScheduleError}
 */
proto.pangolin.protos.SetScheduleResponseInvalid.prototype.getSchedule = function() {
  return /** @type{?proto.pangolin.protos.ScheduleError} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.ScheduleError, 1));
};


/**
 * @param {?proto.pangolin.protos.ScheduleError|undefined} value
 * @return {!proto.pangolin.protos.SetScheduleResponseInvalid} returns this
*/
proto.pangolin.protos.SetScheduleResponseInvalid.prototype.setSchedule = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pangolin.protos.SetScheduleResponseInvalid} returns this
 */
proto.pangolin.protos.SetScheduleResponseInvalid.prototype.clearSchedule = function() {
  return this.setSchedule(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.SetScheduleResponseInvalid.prototype.hasSchedule = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.GetScheduleHostsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.GetScheduleHostsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.GetScheduleHostsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.GetScheduleHostsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    hosts: (f = msg.getHosts()) && proto.pangolin.protos.ScheduleHostIdList.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.GetScheduleHostsResponse}
 */
proto.pangolin.protos.GetScheduleHostsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.GetScheduleHostsResponse;
  return proto.pangolin.protos.GetScheduleHostsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.GetScheduleHostsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.GetScheduleHostsResponse}
 */
proto.pangolin.protos.GetScheduleHostsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.ScheduleHostIdList;
      reader.readMessage(value,proto.pangolin.protos.ScheduleHostIdList.deserializeBinaryFromReader);
      msg.setHosts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.GetScheduleHostsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.GetScheduleHostsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.GetScheduleHostsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.GetScheduleHostsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHosts();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pangolin.protos.ScheduleHostIdList.serializeBinaryToWriter
    );
  }
};


/**
 * required ScheduleHostIdList hosts = 1;
 * @return {!proto.pangolin.protos.ScheduleHostIdList}
 */
proto.pangolin.protos.GetScheduleHostsResponse.prototype.getHosts = function() {
  return /** @type{!proto.pangolin.protos.ScheduleHostIdList} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.ScheduleHostIdList, 1, 1));
};


/**
 * @param {!proto.pangolin.protos.ScheduleHostIdList} value
 * @return {!proto.pangolin.protos.GetScheduleHostsResponse} returns this
*/
proto.pangolin.protos.GetScheduleHostsResponse.prototype.setHosts = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.GetScheduleHostsResponse} returns this
 */
proto.pangolin.protos.GetScheduleHostsResponse.prototype.clearHosts = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.GetScheduleHostsResponse.prototype.hasHosts = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.SetScheduleHostsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.SetScheduleHostsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.SetScheduleHostsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.SetScheduleHostsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    hosts: (f = msg.getHosts()) && proto.pangolin.protos.ScheduleHostIdList.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.SetScheduleHostsRequest}
 */
proto.pangolin.protos.SetScheduleHostsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.SetScheduleHostsRequest;
  return proto.pangolin.protos.SetScheduleHostsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.SetScheduleHostsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.SetScheduleHostsRequest}
 */
proto.pangolin.protos.SetScheduleHostsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.ScheduleHostIdList;
      reader.readMessage(value,proto.pangolin.protos.ScheduleHostIdList.deserializeBinaryFromReader);
      msg.setHosts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.SetScheduleHostsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.SetScheduleHostsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.SetScheduleHostsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.SetScheduleHostsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHosts();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pangolin.protos.ScheduleHostIdList.serializeBinaryToWriter
    );
  }
};


/**
 * required ScheduleHostIdList hosts = 1;
 * @return {!proto.pangolin.protos.ScheduleHostIdList}
 */
proto.pangolin.protos.SetScheduleHostsRequest.prototype.getHosts = function() {
  return /** @type{!proto.pangolin.protos.ScheduleHostIdList} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.ScheduleHostIdList, 1, 1));
};


/**
 * @param {!proto.pangolin.protos.ScheduleHostIdList} value
 * @return {!proto.pangolin.protos.SetScheduleHostsRequest} returns this
*/
proto.pangolin.protos.SetScheduleHostsRequest.prototype.setHosts = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.SetScheduleHostsRequest} returns this
 */
proto.pangolin.protos.SetScheduleHostsRequest.prototype.clearHosts = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.SetScheduleHostsRequest.prototype.hasHosts = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.SetScheduleHostsResponseInvalid.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.SetScheduleHostsResponseInvalid.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.SetScheduleHostsResponseInvalid} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.SetScheduleHostsResponseInvalid.toObject = function(includeInstance, msg) {
  var f, obj = {
    hosts: (f = msg.getHosts()) && proto.pangolin.protos.ScheduleHostErrorMap.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.SetScheduleHostsResponseInvalid}
 */
proto.pangolin.protos.SetScheduleHostsResponseInvalid.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.SetScheduleHostsResponseInvalid;
  return proto.pangolin.protos.SetScheduleHostsResponseInvalid.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.SetScheduleHostsResponseInvalid} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.SetScheduleHostsResponseInvalid}
 */
proto.pangolin.protos.SetScheduleHostsResponseInvalid.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.ScheduleHostErrorMap;
      reader.readMessage(value,proto.pangolin.protos.ScheduleHostErrorMap.deserializeBinaryFromReader);
      msg.setHosts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.SetScheduleHostsResponseInvalid.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.SetScheduleHostsResponseInvalid.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.SetScheduleHostsResponseInvalid} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.SetScheduleHostsResponseInvalid.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHosts();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pangolin.protos.ScheduleHostErrorMap.serializeBinaryToWriter
    );
  }
};


/**
 * required ScheduleHostErrorMap hosts = 1;
 * @return {!proto.pangolin.protos.ScheduleHostErrorMap}
 */
proto.pangolin.protos.SetScheduleHostsResponseInvalid.prototype.getHosts = function() {
  return /** @type{!proto.pangolin.protos.ScheduleHostErrorMap} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.ScheduleHostErrorMap, 1, 1));
};


/**
 * @param {!proto.pangolin.protos.ScheduleHostErrorMap} value
 * @return {!proto.pangolin.protos.SetScheduleHostsResponseInvalid} returns this
*/
proto.pangolin.protos.SetScheduleHostsResponseInvalid.prototype.setHosts = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.SetScheduleHostsResponseInvalid} returns this
 */
proto.pangolin.protos.SetScheduleHostsResponseInvalid.prototype.clearHosts = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.SetScheduleHostsResponseInvalid.prototype.hasHosts = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.GetSchedulePoliciesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.GetSchedulePoliciesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.GetSchedulePoliciesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.GetSchedulePoliciesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    policies: (f = msg.getPolicies()) && proto.pangolin.protos.SchedulePolicyObjectMap.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.GetSchedulePoliciesResponse}
 */
proto.pangolin.protos.GetSchedulePoliciesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.GetSchedulePoliciesResponse;
  return proto.pangolin.protos.GetSchedulePoliciesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.GetSchedulePoliciesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.GetSchedulePoliciesResponse}
 */
proto.pangolin.protos.GetSchedulePoliciesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.SchedulePolicyObjectMap;
      reader.readMessage(value,proto.pangolin.protos.SchedulePolicyObjectMap.deserializeBinaryFromReader);
      msg.setPolicies(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.GetSchedulePoliciesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.GetSchedulePoliciesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.GetSchedulePoliciesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.GetSchedulePoliciesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPolicies();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pangolin.protos.SchedulePolicyObjectMap.serializeBinaryToWriter
    );
  }
};


/**
 * required SchedulePolicyObjectMap policies = 1;
 * @return {!proto.pangolin.protos.SchedulePolicyObjectMap}
 */
proto.pangolin.protos.GetSchedulePoliciesResponse.prototype.getPolicies = function() {
  return /** @type{!proto.pangolin.protos.SchedulePolicyObjectMap} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.SchedulePolicyObjectMap, 1, 1));
};


/**
 * @param {!proto.pangolin.protos.SchedulePolicyObjectMap} value
 * @return {!proto.pangolin.protos.GetSchedulePoliciesResponse} returns this
*/
proto.pangolin.protos.GetSchedulePoliciesResponse.prototype.setPolicies = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.GetSchedulePoliciesResponse} returns this
 */
proto.pangolin.protos.GetSchedulePoliciesResponse.prototype.clearPolicies = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.GetSchedulePoliciesResponse.prototype.hasPolicies = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.SetSchedulePoliciesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.SetSchedulePoliciesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.SetSchedulePoliciesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.SetSchedulePoliciesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    policies: (f = msg.getPolicies()) && proto.pangolin.protos.SchedulePolicyObjectMap.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.SetSchedulePoliciesRequest}
 */
proto.pangolin.protos.SetSchedulePoliciesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.SetSchedulePoliciesRequest;
  return proto.pangolin.protos.SetSchedulePoliciesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.SetSchedulePoliciesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.SetSchedulePoliciesRequest}
 */
proto.pangolin.protos.SetSchedulePoliciesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.SchedulePolicyObjectMap;
      reader.readMessage(value,proto.pangolin.protos.SchedulePolicyObjectMap.deserializeBinaryFromReader);
      msg.setPolicies(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.SetSchedulePoliciesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.SetSchedulePoliciesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.SetSchedulePoliciesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.SetSchedulePoliciesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPolicies();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pangolin.protos.SchedulePolicyObjectMap.serializeBinaryToWriter
    );
  }
};


/**
 * required SchedulePolicyObjectMap policies = 1;
 * @return {!proto.pangolin.protos.SchedulePolicyObjectMap}
 */
proto.pangolin.protos.SetSchedulePoliciesRequest.prototype.getPolicies = function() {
  return /** @type{!proto.pangolin.protos.SchedulePolicyObjectMap} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.SchedulePolicyObjectMap, 1, 1));
};


/**
 * @param {!proto.pangolin.protos.SchedulePolicyObjectMap} value
 * @return {!proto.pangolin.protos.SetSchedulePoliciesRequest} returns this
*/
proto.pangolin.protos.SetSchedulePoliciesRequest.prototype.setPolicies = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.SetSchedulePoliciesRequest} returns this
 */
proto.pangolin.protos.SetSchedulePoliciesRequest.prototype.clearPolicies = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.SetSchedulePoliciesRequest.prototype.hasPolicies = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.SetSchedulePoliciesResponseInvalid.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.SetSchedulePoliciesResponseInvalid.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.SetSchedulePoliciesResponseInvalid} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.SetSchedulePoliciesResponseInvalid.toObject = function(includeInstance, msg) {
  var f, obj = {
    policies: (f = msg.getPolicies()) && proto.pangolin.protos.SchedulePolicyErrorMap.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.SetSchedulePoliciesResponseInvalid}
 */
proto.pangolin.protos.SetSchedulePoliciesResponseInvalid.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.SetSchedulePoliciesResponseInvalid;
  return proto.pangolin.protos.SetSchedulePoliciesResponseInvalid.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.SetSchedulePoliciesResponseInvalid} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.SetSchedulePoliciesResponseInvalid}
 */
proto.pangolin.protos.SetSchedulePoliciesResponseInvalid.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.SchedulePolicyErrorMap;
      reader.readMessage(value,proto.pangolin.protos.SchedulePolicyErrorMap.deserializeBinaryFromReader);
      msg.setPolicies(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.SetSchedulePoliciesResponseInvalid.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.SetSchedulePoliciesResponseInvalid.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.SetSchedulePoliciesResponseInvalid} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.SetSchedulePoliciesResponseInvalid.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPolicies();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pangolin.protos.SchedulePolicyErrorMap.serializeBinaryToWriter
    );
  }
};


/**
 * required SchedulePolicyErrorMap policies = 1;
 * @return {!proto.pangolin.protos.SchedulePolicyErrorMap}
 */
proto.pangolin.protos.SetSchedulePoliciesResponseInvalid.prototype.getPolicies = function() {
  return /** @type{!proto.pangolin.protos.SchedulePolicyErrorMap} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.SchedulePolicyErrorMap, 1, 1));
};


/**
 * @param {!proto.pangolin.protos.SchedulePolicyErrorMap} value
 * @return {!proto.pangolin.protos.SetSchedulePoliciesResponseInvalid} returns this
*/
proto.pangolin.protos.SetSchedulePoliciesResponseInvalid.prototype.setPolicies = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.pangolin.protos.SetSchedulePoliciesResponseInvalid} returns this
 */
proto.pangolin.protos.SetSchedulePoliciesResponseInvalid.prototype.clearPolicies = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.SetSchedulePoliciesResponseInvalid.prototype.hasPolicies = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.GetSchedulePolicyResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.GetSchedulePolicyResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.GetSchedulePolicyResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.GetSchedulePolicyResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    policy: (f = msg.getPolicy()) && proto.pangolin.protos.SchedulePolicyObject.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.GetSchedulePolicyResponse}
 */
proto.pangolin.protos.GetSchedulePolicyResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.GetSchedulePolicyResponse;
  return proto.pangolin.protos.GetSchedulePolicyResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.GetSchedulePolicyResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.GetSchedulePolicyResponse}
 */
proto.pangolin.protos.GetSchedulePolicyResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.SchedulePolicyObject;
      reader.readMessage(value,proto.pangolin.protos.SchedulePolicyObject.deserializeBinaryFromReader);
      msg.setPolicy(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.GetSchedulePolicyResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.GetSchedulePolicyResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.GetSchedulePolicyResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.GetSchedulePolicyResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPolicy();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pangolin.protos.SchedulePolicyObject.serializeBinaryToWriter
    );
  }
};


/**
 * optional SchedulePolicyObject policy = 1;
 * @return {?proto.pangolin.protos.SchedulePolicyObject}
 */
proto.pangolin.protos.GetSchedulePolicyResponse.prototype.getPolicy = function() {
  return /** @type{?proto.pangolin.protos.SchedulePolicyObject} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.SchedulePolicyObject, 1));
};


/**
 * @param {?proto.pangolin.protos.SchedulePolicyObject|undefined} value
 * @return {!proto.pangolin.protos.GetSchedulePolicyResponse} returns this
*/
proto.pangolin.protos.GetSchedulePolicyResponse.prototype.setPolicy = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pangolin.protos.GetSchedulePolicyResponse} returns this
 */
proto.pangolin.protos.GetSchedulePolicyResponse.prototype.clearPolicy = function() {
  return this.setPolicy(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.GetSchedulePolicyResponse.prototype.hasPolicy = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.SetSchedulePolicyRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.SetSchedulePolicyRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.SetSchedulePolicyRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.SetSchedulePolicyRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    policy: (f = msg.getPolicy()) && proto.pangolin.protos.SchedulePolicyObject.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.SetSchedulePolicyRequest}
 */
proto.pangolin.protos.SetSchedulePolicyRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.SetSchedulePolicyRequest;
  return proto.pangolin.protos.SetSchedulePolicyRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.SetSchedulePolicyRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.SetSchedulePolicyRequest}
 */
proto.pangolin.protos.SetSchedulePolicyRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.SchedulePolicyObject;
      reader.readMessage(value,proto.pangolin.protos.SchedulePolicyObject.deserializeBinaryFromReader);
      msg.setPolicy(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.SetSchedulePolicyRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.SetSchedulePolicyRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.SetSchedulePolicyRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.SetSchedulePolicyRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPolicy();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pangolin.protos.SchedulePolicyObject.serializeBinaryToWriter
    );
  }
};


/**
 * optional SchedulePolicyObject policy = 1;
 * @return {?proto.pangolin.protos.SchedulePolicyObject}
 */
proto.pangolin.protos.SetSchedulePolicyRequest.prototype.getPolicy = function() {
  return /** @type{?proto.pangolin.protos.SchedulePolicyObject} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.SchedulePolicyObject, 1));
};


/**
 * @param {?proto.pangolin.protos.SchedulePolicyObject|undefined} value
 * @return {!proto.pangolin.protos.SetSchedulePolicyRequest} returns this
*/
proto.pangolin.protos.SetSchedulePolicyRequest.prototype.setPolicy = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pangolin.protos.SetSchedulePolicyRequest} returns this
 */
proto.pangolin.protos.SetSchedulePolicyRequest.prototype.clearPolicy = function() {
  return this.setPolicy(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.SetSchedulePolicyRequest.prototype.hasPolicy = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pangolin.protos.SetSchedulePolicyResponseInvalid.prototype.toObject = function(opt_includeInstance) {
  return proto.pangolin.protos.SetSchedulePolicyResponseInvalid.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pangolin.protos.SetSchedulePolicyResponseInvalid} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.SetSchedulePolicyResponseInvalid.toObject = function(includeInstance, msg) {
  var f, obj = {
    policy: (f = msg.getPolicy()) && proto.pangolin.protos.SchedulePolicyError.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pangolin.protos.SetSchedulePolicyResponseInvalid}
 */
proto.pangolin.protos.SetSchedulePolicyResponseInvalid.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pangolin.protos.SetSchedulePolicyResponseInvalid;
  return proto.pangolin.protos.SetSchedulePolicyResponseInvalid.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pangolin.protos.SetSchedulePolicyResponseInvalid} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pangolin.protos.SetSchedulePolicyResponseInvalid}
 */
proto.pangolin.protos.SetSchedulePolicyResponseInvalid.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pangolin.protos.SchedulePolicyError;
      reader.readMessage(value,proto.pangolin.protos.SchedulePolicyError.deserializeBinaryFromReader);
      msg.setPolicy(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pangolin.protos.SetSchedulePolicyResponseInvalid.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pangolin.protos.SetSchedulePolicyResponseInvalid.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pangolin.protos.SetSchedulePolicyResponseInvalid} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pangolin.protos.SetSchedulePolicyResponseInvalid.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPolicy();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.pangolin.protos.SchedulePolicyError.serializeBinaryToWriter
    );
  }
};


/**
 * optional SchedulePolicyError policy = 1;
 * @return {?proto.pangolin.protos.SchedulePolicyError}
 */
proto.pangolin.protos.SetSchedulePolicyResponseInvalid.prototype.getPolicy = function() {
  return /** @type{?proto.pangolin.protos.SchedulePolicyError} */ (
    jspb.Message.getWrapperField(this, proto.pangolin.protos.SchedulePolicyError, 1));
};


/**
 * @param {?proto.pangolin.protos.SchedulePolicyError|undefined} value
 * @return {!proto.pangolin.protos.SetSchedulePolicyResponseInvalid} returns this
*/
proto.pangolin.protos.SetSchedulePolicyResponseInvalid.prototype.setPolicy = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pangolin.protos.SetSchedulePolicyResponseInvalid} returns this
 */
proto.pangolin.protos.SetSchedulePolicyResponseInvalid.prototype.clearPolicy = function() {
  return this.setPolicy(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pangolin.protos.SetSchedulePolicyResponseInvalid.prototype.hasPolicy = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * @enum {number}
 */
proto.pangolin.protos.SchedulePolicyKind = {
  P_UNKNOWN: 0,
  P_CATEGORY: 1,
  P_CUSTOM: 2
};

/**
 * @enum {number}
 */
proto.pangolin.protos.SchedulePolicyCategory = {
  C_UNKNOWN: 0,
  C_ADULT: 1,
  C_ENTERTAINMENT: 2,
  C_GAMES: 3,
  C_SOCIAL: 4
};

goog.object.extend(exports, proto.pangolin.protos);
